import { getPerformanceContext } from "@aibotdev/ct-analytics"
import { useEffect } from "react"
import { selectConfigState } from "../store/config/selectors"
import { useAppSelector } from "../store/hooks"
import { logError } from "../utility/common/logError"
import { addSystemMetrics, initializeMetrics } from "./metricsManager"
import reportWebVitals from "./reportWebVitals"

const { getPerformanceObserver } = getPerformanceContext(addSystemMetrics)

export function logPerformanceObserverInitializingError(name: string, e: unknown) {
    logError(`Failed to initialize ${name} PerformanceObserver`, e)
}

export const useMetricsInitializer = () => {
    const configState = useAppSelector(selectConfigState)

    useEffect(() => {
        if (!configState.error && configState.data?.WebConfig.appSettings.metricsEnabled) {
            try {
                initializeMetrics()
                reportWebVitals(addSystemMetrics)
                const observer = getPerformanceObserver("Global")
                observer.observe({ type: "measure", buffered: true })
            } catch (e) {
                logError("Failed to initialize performance metrics", e)
            }
        }
    }, [configState.data, configState.error])
}
